import { DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';
import Form from 'components/@forms/Form';
import type { SubmitHandler } from 'components/@forms/types';

import { useOpenEmailFlow } from './hooks';
import AuthMethod from './steps/AuthMethod';
import CheckInbox from './steps/CheckInbox';
import EmailLink from './steps/EmailLink';
import { LoginFormFields } from './types';

interface Props {
  titleIntlId: string;
  emailSent: boolean;
  afterSignInUrl: string;
  isLoadingEmailLink: boolean;
  open: boolean;
  originSourceCategory: string;
  onClose: () => void;
  onResetEmailFlow: () => void;
  onSubmit: SubmitHandler<LoginFormFields>;
}

const AuthenticationDrawer = ({
  titleIntlId,
  open,
  emailSent,
  afterSignInUrl,
  isLoadingEmailLink,
  originSourceCategory,
  onClose,
  onResetEmailFlow,
  onSubmit,
}: Props) => {
  const { isEmailFlow, handleOpenEmailFlow, handleCloseEmailFlow } =
    useOpenEmailFlow();

  const handleCloseAuthDrawer = () => {
    handleCloseEmailFlow();
    onClose();
  };

  return (
    <ResponsiveDrawerDialog
      isOpen={open}
      onClose={handleCloseAuthDrawer}
      stackPriority={1}
      onBack={
        !isEmailFlow
          ? undefined
          : emailSent
            ? onResetEmailFlow
            : handleCloseEmailFlow
      }
      dialogProps={{ maxWidth: 'xs' }}
    >
      {!emailSent && !isEmailFlow && (
        <>
          <DialogTitle>
            <FormattedMessage id={titleIntlId} />
          </DialogTitle>
          <DialogContent>
            <AuthMethod
              afterSignInUrl={afterSignInUrl}
              onEmailFlow={handleOpenEmailFlow}
              originSourceCategory={originSourceCategory}
            />
          </DialogContent>
        </>
      )}
      {isEmailFlow && (
        <Form onSubmit={onSubmit} defaultValues={{ emailAddress: '' }}>
          {!emailSent ? (
            <EmailLink isLoadingEmailLink={isLoadingEmailLink} />
          ) : (
            <CheckInbox afterSignInUrl={afterSignInUrl} />
          )}
        </Form>
      )}
    </ResponsiveDrawerDialog>
  );
};

export default AuthenticationDrawer;
